import { render, staticRenderFns } from "./TheMaterials.vue?vue&type=template&id=1cd4d50e&"
import script from "./TheMaterials.vue?vue&type=script&lang=js&"
export * from "./TheMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports